import React from 'react';
//@ts-ignore
import style from './CenteredLoadingSpinner.module.scss?module';
import Spinner1 from '../Spinner1/Spinner1';

const CenteredLoadingSpinner = () => {
  return (
    <div
      className={`${style.loadingSpinnerContainer} d-flex justify-content-center align-items-center vh-100 w-100`}
    >
      <Spinner1 />
    </div>
  );
};

export default CenteredLoadingSpinner;
